<template>
  <div>

    <iframe src="https://docs.google.com/document/d/e/2PACX-1vT-nesumJ3XfppZOLEo6UD2RNstyaEhYoukz0xlvkF6HaM2l7jDXWlLNi9-_MpqmI-ezKda2gKdEXYw/pub?embedded=true" width="100%" height="650px"></iframe>  

  </div>
</template>

<script>
export default {

}
</script>

<style>

</style>